import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=371ae714&scoped=true&"
import script from "./BranchCard.vue?vue&type=script&lang=js&"
export * from "./BranchCard.vue?vue&type=script&lang=js&"
import style0 from "./BranchCard.vue?vue&type=style&index=0&id=371ae714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ae714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371ae714')) {
      api.createRecord('371ae714', component.options)
    } else {
      api.reload('371ae714', component.options)
    }
    module.hot.accept("./BranchCard.vue?vue&type=template&id=371ae714&scoped=true&", function () {
      api.rerender('371ae714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/BranchCard.vue"
export default component.exports